import _ from "lodash";
import * as ActionType from "../actionType";
import { fetchLogin, fetchGetProfile } from "../../services/page/auth";

const setLogin = (dispatch, data) => {
  dispatch({
    type: ActionType.RECEIVE_AUTH,
    data
  });
  dispatch({
    type: ActionType.IS_LOGIN,
    isLogin: true
  });
};

const getProfile = async dispatch => {
  const token = window.localStorage.getItem("token");
  dispatch({
    type: ActionType.SET_AUTH_TOKEN,
    token
  });
  const profileResult = await fetchGetProfile(token);
  if (_.get(profileResult, "status") === "success") {
    const data = _.get(profileResult, "data");
    setLogin(dispatch, data);
  }
  dispatch({
    type: ActionType.IS_LOGIN_CHECKED,
    isLoginChecked: true
  });
  return profileResult;
};

const getProfileAction = () => {
  return async dispatch => {
    const profileResult = await getProfile(dispatch);
    return profileResult;
  };
};

const loginAction = (uid, password) => {
  return async dispatch => {
    const loginResult = await fetchLogin(uid, password);
    if (_.get(loginResult, "status") === "success") {
      const token = _.get(loginResult, "data.token");
      window.localStorage.setItem("token", token);
      await getProfile(dispatch);
    } else {
      dispatch({
        type: ActionType.IS_LOGIN_CHECKED,
        isLoginChecked: true
      });
    }
    return loginResult;
  };
};

const logoutAction = () => {
  return dispatch => {
    window.localStorage.removeItem("token");
    dispatch({
      type: ActionType.IS_LOGIN,
      isLogin: false
    });
    dispatch({
      type: ActionType.RECEIVE_AUTH,
      data: {}
    });
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };
};

export { loginAction, logoutAction, getProfileAction, getProfile };



// WEBPACK FOOTER //
// ./src/actions/page/auth.js